import { useDispatch, useSelector } from 'react-redux';
import { 
  selectDomesticHelperFlow,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  nextStep,
  previousStep,
  nextSubstep,
  previousSubstep
} from '../redux/features/domesticHelperFlowSlice';
import { 
  STEP_NAME_START,
  STEP_NAME_APPLICATION_DETAILS,
  STEP_NAME_ABOUT_YOUR_HELPER,
  STEP_NAME_HELPER_BASIC,
  STEP_NAME_HELPER_EMPLOYMENT,
  STEP_NAME_HELPER_ADDITIONAL,
  STEP_NAME_CONTRACT_DETAILS,
  STEP_NAME_PLAN_SELECTION,
  STEP_NAME_COVERAGE_OPTIONS,
  STEP_NAME_DOCUMENTS,
  STEP_NAME_SUMMARY
} from '../pages/domesticHelperPages/newDomesticHelperPolicy/data';

// Flow configuration following travel insurance pattern
const DOMESTIC_HELPER_FLOW = {
  default: [
    {
      name: STEP_NAME_START,
      substeps: ['basic_info', 'documents_ready']
    },
    {
      name: STEP_NAME_APPLICATION_DETAILS
    },
    {
      name: STEP_NAME_ABOUT_YOUR_HELPER
    },
    {
      name: STEP_NAME_DOCUMENTS
    },
    {
      name: STEP_NAME_SUMMARY,
      substeps: ['review_summary']
    }
  ]
};

const useDomesticHelperFlow = () => {
  const dispatch = useDispatch();
  const flow = useSelector(selectDomesticHelperFlow);
  
  const currentStepIndex = flow?.currentStepIndex || 0;
  const currentSubstepIndex = flow?.currentSubstepIndex || 0;
  
  const steps = DOMESTIC_HELPER_FLOW.default || [];
  const currentStep = steps[currentStepIndex] || {};
  const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

  const handleNextStep = () => {
    dispatch(nextStep());
  };

  const handlePreviousStep = () => {
    dispatch(previousStep());
  };

  const handlePrevStep = () => {
    dispatch(previousStep());
  };

  const handleNextSubstep = () => {
    if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
      dispatch(nextSubstep());
    } else if (currentSubstepIndex === (currentStep.substeps?.length - 1 || 0)) {
      handleNextStep();
    }
  };

  const handlePreviousSubstep = () => {
    if (currentSubstepIndex > 0) {
      dispatch(previousSubstep());
    } else {
      handlePreviousStep();
    }
  };

  const handlePrevSubstep = () => {
    if (currentSubstepIndex > 0) {
      dispatch(previousSubstep());
    } else {
      handlePreviousStep();
    }
  };

  const setStep = (stepIndex) => {
    dispatch(setCurrentStepIndex(stepIndex));
    dispatch(setCurrentSubstepIndex(0));
  };

  return {
    currentStep,
    currentSubstep,
    currentStepIndex,
    currentSubstepIndex,
    steps,
    handleNextStep,
    handlePreviousStep,
    handlePrevStep,
    handleNextSubstep,
    handlePreviousSubstep,
    handlePrevSubstep,
    setStep
  };
};

export default useDomesticHelperFlow;